jQuery(document).ready(function($){
  if($('.o-caption-description-slider')[0]){
    $('.o-caption-description-slider__slider').slick({
      // adaptiveHeight: true,
      slidesToScroll: 1,
      slidesToShow: 3,
      arrows: true,
      dots: true,
      appendArrows: $('.o-caption-description-slider__arrows'),
      appendDots: $('.o-caption-description-slider__dots'),
      responsive: [
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 2,
            }
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 1,
          }
        }
      ],
    });
  }
})